import React, { Component } from "react";
import ProjectDetailsModal from "./ProjectDetailsModal";
import Slider from "../components/Slider";
import { Fade } from "react-awesome-reveal";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProject: null, // Stocke les données du projet sélectionné
      detailsModalShow: false, // Contrôle l'affichage de la modal
    };
  }

  // Fonction pour afficher la modal avec les données du projet
  handleProjectClick = (project) => {
    this.setState({ selectedProject: project, detailsModalShow: true });
  };

  // Fonction pour fermer la modal
  handleCloseModal = () => {
    this.setState({ detailsModalShow: false, selectedProject: null });
  };

  render() {
    const sectionName = this.props.resumeBasicInfo?.section_name?.projects || "";
    const projects = this.props.resumeProjects || [];

    return (
      <section id="portfolio">
        <div className="section-two">
        <Fade triggerOnce={true} duration={1500} direction="up" fraction={0.2}>
          <div className="col-md-12">
            <div className="section-title" style={{ color: "black" }}>
              <h1>{sectionName}</h1>
            </div>
            <Slider projects={projects} onProjectClick={this.handleProjectClick} />

            {this.state.selectedProject && (
              <ProjectDetailsModal
                show={this.state.detailsModalShow}
                onHide={this.handleCloseModal}
                data={this.state.selectedProject}
              />
            )}
          </div>
          </Fade>
        </div>
      </section>
    );
  }
}

export default Projects;
